export const buttonInnerTextFontSize = '22px';
export const buttonInnerTextFontWeight = '600';
export const buttonBorderRadius = '8px';
export const buttonPadding = '13px 30px';

export const buttonIconDiameter = '20px';
export const addButtonDiameter = '64px';
